import { Toolbar } from 'ngx-editor';

export const ToolbarConfig = [
    ['undo', 'redo'],
    ['bold', 'italic', 'underline', 'strike'],
    [{ heading: ['h1', 'h2', 'h3'] }],
    ['ordered_list', 'bullet_list'],
    ['code', 'blockquote'],
    ['indent', 'outdent'],
    ['format_clear']
] as Toolbar;

export const ColorPresetsConfig = [];
